/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AuthenticatingInputs */

const en_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticating`)
};

const es_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticando`)
};

const fr_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification en cours`)
};

const de_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird authentifiziert`)
};

const ja_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証中`)
};

const zh_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在验证`)
};

const ar_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري المصادقة`)
};

const id_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengautentikasi`)
};

const it_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticazione in corso`)
};

const ru_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аутентификация`)
};

const pt_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticando`)
};

const ko_authenticating = /** @type {(inputs: AuthenticatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증 중`)
};

/**
* | output |
* | --- |
* | "Authenticating" |
*
* @param {AuthenticatingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const authenticating = /** @type {((inputs?: AuthenticatingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AuthenticatingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authenticating(inputs)
	if (locale === "es") return es_authenticating(inputs)
	if (locale === "fr") return fr_authenticating(inputs)
	if (locale === "de") return de_authenticating(inputs)
	if (locale === "ja") return ja_authenticating(inputs)
	if (locale === "zh") return zh_authenticating(inputs)
	if (locale === "ar") return ar_authenticating(inputs)
	if (locale === "id") return id_authenticating(inputs)
	if (locale === "it") return it_authenticating(inputs)
	if (locale === "ru") return ru_authenticating(inputs)
	if (locale === "pt") return pt_authenticating(inputs)
	return ko_authenticating(inputs)
});